const firstString = (...candidates: any[]): string | undefined => {
  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate) {
      return candidate;
    }
  }
  return undefined;
};

/**
 * The provider's reason for refusing the charge, as text — the backend answers a
 * declined card with `{ error: 'Bad Request', message: 'Your card was declined.',
 * statusCode: 400 }` and sends no machine-readable decline code, so this message
 * is what the payment error events report.
 *
 * The backend payload wins over `error.message`: on a raw axios failure the
 * latter is the useless "Request failed with status code 400". Behind the
 * billing interceptor (packages/module-billing/api/network.js) both hold the
 * same text, so the order is safe.
 */
export const extractPaymentErrorMessage = (error: any): string | undefined => {
  if (!error) {
    return undefined;
  }

  if (typeof error === 'string') {
    return error;
  }

  const data = error.data || error.response?.data || {};
  const nested = data.error || error.error || {};

  return firstString(
    data.message,
    nested.message,
    error.message,
    // Some endpoints put the text straight into `error` (`error: 'Bad Request'`).
    typeof data.error === 'string' ? data.error : undefined
  );
};
